import React, { useState, useEffect, useRef } from 'react';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/initialize';

const CustomDateInput = props => {
  const {
    date,
    setDate,
    id,
    placeholder,
    isDatePickerOpen: externalIsOpen,
    setIsDatePickerOpen: externalSetIsOpen,
  } = props;
  const [focused, setFocused] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const datePickerRef = useRef(null);

  useEffect(() => {
    setMounted(true);
    import('react-dates/lib/css/_datepicker.css');
    import('./singleDatePicker.css');
  }, []);

  useEffect(() => {
    if (isOpen) {
      setFocused(true);
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = event => {
      if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
        setIsOpen(false);
        setFocused(false);
        if (externalSetIsOpen) {
          externalSetIsOpen(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [externalSetIsOpen]);

  if (!mounted) {
    return <div className="custom-date-picker-placeholder" />;
  }

  return (
    <div
      className="custom-date-picker"
      ref={datePickerRef}
      onClick={() => {
        setIsOpen(true);
        if (externalSetIsOpen) {
          externalSetIsOpen(true);
        }
      }}
    >
      <SingleDatePicker
        date={date}
        onDateChange={newDate => setDate(newDate)}
        focused={focused}
        onFocusChange={({ focused }) => {
          setFocused(focused);
          if (!focused) {
            setIsOpen(false);
            if (externalSetIsOpen) {
              externalSetIsOpen(false);
            }
          }
        }}
        id={id}
        placeholder={placeholder}
        displayFormat="DD.MM"
        numberOfMonths={1}
        readOnly
      />
    </div>
  );
};

export default CustomDateInput;
